<template>
  <footer class="footer">
    <div
      class="footer__row-wrapper"
    >
      <div class="footer__row">
        <div class="footer__logotypes">
          <img
            class="footer__logotypes__image"
            :src="`${baseAssetsUrl}/staticImages/packster-logo-footer.svg`"
            :alt="$t('footer.logo.alt')"
            height="34"
            width="150"
            loading="lazy"
          >
        </div>
        <div class="footer__wrapper">
          <footer-teaser
            class="footer__column ordered-mobile_2"
            v-if="footerTeaserTabs.length"
            :tabs="footerTeaserTabs"
          />
          <div class="footer__column ordered-mobile_1">
            <div class="footer__contact">
              <a
                :href="$t('meta.content.header.phone')"
                class="footer__phone"
              >
                {{ $t('meta.content.header.phone.string') }}
              </a>
              <a
                :href="$t('contact.headline.url')"
                :aria-label="$t('contact.mail.link.button')"
                class="footer__mail"
              >
                {{ $t('contact.mail.label.vue3') }}
              </a>
            </div>
          </div>
          <div class="footer__column ordered-mobile_2">
            <div class="footer__payments">
              <ul>
                <li class="footer__payments--methods">
                  <span class="footer__payments--vorkasse">{{ $t('checkout.payment_type.PREPAID') }}</span>
                  <span class="footer__payments--rechnung">{{ $t('checkout.payment_type.INVOICE_FOOTER') }}</span>
                </li>
                <li class="footer__payments--creditcard">
                  <img
                    :src="baseAssetsUrl + '/staticImages/mastercard.svg'"
                    :alt="$t('checkout.payment_type.MASTERCARD')"
                    height="54"
                    width="52"
                    loading="lazy"
                  >
                  <img
                    :src="baseAssetsUrl + '/staticImages/visa.svg'"
                    :alt="$t('checkout.payment_type.VISA')"
                    height="54"
                    width="52"
                    loading="lazy"
                  >
                  <img
                    :src="baseAssetsUrl + '/staticImages/paypal.svg'"
                    :alt="$t('checkout.payment_type.PAYPAL')"
                    height="54"
                    width="52"
                    loading="lazy"
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span class="footer__subtext">{{ $t('footer_navi_legal.copyright') }}</span>
      </div>
      <div class="footer__row">
        <div class="footer__wrapper">
          <div class="footer__logotypes">
            <a
              href="https://www.co2neutralwebsite.de/certificate/6796/de"
              class="footer__logotypes--link"
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              <img
                class="footer__logotypes__image"
                :src="`${baseAssetsUrl}/staticImages/klimaprojekte-DE-Inverse.png`"
                :alt="$t('footer.co2.logo.alt')"
                height="96"
                width="280"
                loading="lazy"
              >
            </a>
          </div>
        </div>
      </div>
    </div>
    <success-logout />
  </footer>
</template>
<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import FooterTeaser from '../footerTeaser/footerTeaser.vue';
  import ServiceLinks from '../serviceLinks/serviceLinks.vue';
  import cookieConsentManager from '../cookieConsentManager/cookieConsentManager.js';
  import SuccessLogout from "../successLogout/successLogout.vue";

  export default {
    components: {
      FooterTeaser,
      ServiceLinks,
      SuccessLogout
    },
    mixins: [
      globalStateComputedMixin
    ],
    props: {
      isCheckout: {
        type: Boolean,
        default: false
      },
      logoTypes: Array,
      footerTeaserTabs: Array,
      socialMedia: Array,
      serviceLinks: Array
    },
    created() {
      cookieConsentManager.callConsentManager();
    },
  };

</script>
